import React, { useState, useEffect, useRef } from "react";
import PortableText from "./portableText";
import clientConfig from "../../client-config";
import VideoModal from "./videoModal";
import Helmet from 'react-helmet';
import * as styles from './lookUpWidget.module.css';
import { gsap, TweenMax, Expo } from "gsap";
import Autocomplete from "react-google-autocomplete";

import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";

const googleAPIKey = 'AIzaSyBJ0jUqHmkIOFeN554V38lBU1GIsJQ1sX4';
const autoCompleteOptions = { types : ['address'], componentRestrictions:{country:'au'} };

const maybeImage = illustration => {
    let img = null;
    if (illustration && illustration.image && illustration.image.asset && !illustration.disabled) {
        const imageData = getGatsbyImageData(
        illustration.image,
        { maxWidth: 960 },
        clientConfig.sanity
        );
    
        img = (
        <GatsbyImage
            image={imageData}
            alt={illustration.image.alt}
        />
        );
    }
    return img;
};

function LookUpWidget(props) {

    
    let heroBg = (props.backgroundImage) ? props.backgroundImage.image.asset.url : '';
    
    let hasWistia = (props.wistiaId) ? true : false;

    let desktopBgClass = styles.sectionBg + ' ' +styles.sectionBgDesktop;
    let mobileBgClass = styles.sectionBg + ' ' +styles.sectionBgMobile;

    let containerClass = styles.sectionContainer + ' mx-auto';

    const [videoModalOpen, setVideoModalOpen] = useState(false);
    const [videoSrc, setVideoSrc] = useState(props.videoLink);

    let openVideoModal = () => {
        setVideoSrc(props.videoLink);
        setVideoModalOpen(true);
    }

    let closeVideoModal = () => {
        setVideoModalOpen(false);
        setVideoSrc('');
    }

    const featuredimg = maybeImage(props.image);
    let bgImageDesktop = (props.bgimagedesktop) ? ( (props.bgimagedesktop.image) ? props.bgimagedesktop.image.asset.url : false) : false;
    let bgImageMobile = (props.bgimagemobile) ? ( (props.bgimagemobile.image) ? props.bgimagemobile.image.asset.url : bgImageDesktop) : bgImageDesktop;
    let bgColor = (props.bgcolor) ? props.bgcolor.hex : '#FFFFFF';

    
    let icon1 = (props.icon_1) ? ( (props.icon_1.image) ? props.icon_1.image.asset.url : false) : false;
    let icon1_alt = (props.icon_1) ? ( (props.icon_1.image) ? props.icon_1.image.alt : false) : false;
    let icon2 = (props.icon_2) ? ( (props.icon_2.image) ? props.icon_2.image.asset.url : false) : false;
    let icon2_alt = (props.icon_2) ? ( (props.icon_2.image) ? props.icon_2.image.alt : false) : false;
    let icon1_link = (props.icon_1_link) ? props.icon_1_link : '#';
    let icon1_class = (icon1_link != '#') ? styles.iconLink : styles.iconLink+' '+styles.iconLink_disabled;
    let icon2_link = (props.icon_2_link) ? props.icon_2_link : '#';
    let icon2_class = (icon2_link != '#') ? styles.iconLink : styles.iconLink+' '+styles.iconLink_disabled;


    const sectionRef = useRef();
    const titleRef = useRef();
    const contentRef = useRef();
    const bgRef = useRef();
    const inputWrapRef = useRef();
    const clearBtn = useRef();
    const searchBtn = useRef();
    const wistiaRef = useRef();

    useEffect(() => {

        $('head').append('<style>.pac-logo:after{display:none !important;}.pac-selection-header{font-size:16px;font-weight:600;padding:24px 18px;}.pac-item{padding: 10px 18px; border: 0; cursor:pointer;}.pac-item span{font-size:14px;font-family: "Poppins", sans-serif;}</style>');
        $('.pac-selection-header').remove();
        $('.pac-container').prepend('<h5 class="pac-selection-header">Select your address below</h5>');
        $(inputWrapRef.current).find('input').attr('placeholder', 'Type in your address');

        if(!$(inputWrapRef.current).hasClass('kp-binded')){
            $(inputWrapRef.current).find('input').on('input', function(){
                $(inputWrapRef.current).addClass('kp-binded');
                let val = $(inputWrapRef.current).find('input').val();
                if(val.length > 0){
                    $(searchBtn.current).hide();
                    $(clearBtn.current).show();
                } else {
                    $(searchBtn.current).show();
                    $(clearBtn.current).hide();
                }
            });
            $(clearBtn.current).bind('click', function(){
                $(inputWrapRef.current).find('input').val('');
                $(searchBtn.current).show();
                $(clearBtn.current).hide();
            });
        }

        let isInViewport = (ins, os) => {
            let offset = (os) ? os : 0;
            if(ins.offset()){
                let elementTop = ins.offset().top + 10 - offset;
                let elementBottom = elementTop + ins.outerHeight() - offset;
                let viewportTop = $(window).scrollTop();
                let viewportBottom = viewportTop + $(window).height();
                return elementBottom > viewportTop && elementTop < viewportBottom;
            }
            return false;
        }

        // TweenMax.set([titleRef.current, contentRef.current, ctaRef.current], {
        //     opacity: 0,
        //     y: 100
        // });
        // TweenMax.to(
        //     titleRef.current, 
        //     0.45, 
        //     { 
        //         opacity: 1, 
        //         y: -25, 
        //         delay : 0.35, 
        //         onComplete : () => {
        //             TweenMax.to(
        //                 titleRef.current,
        //                 0.3,
        //                 {
        //                     y: 0,
        //                 }
        //             )
        //         }
        //     } 
        // );
        // TweenMax.to(
        //     contentRef.current, 
        //     0.45, 
        //     { 
        //         opacity: 1, 
        //         y: -25, 
        //         delay : 0.55, 
        //         onComplete : () => {
        //             TweenMax.to(
        //                 contentRef.current,
        //                 0.3,
        //                 {
        //                     y: 0,
        //                 }
        //             )
        //             $(sectionRef.current).addClass('anim-complete');
        //         }
        //     } 
        // );
        
        // TweenMax.to(
        //     ctaRef.current, 
        //     0.45, 
        //     { 
        //         opacity: 1, 
        //         y: 0, 
        //         delay : 0.75
        //     } 
        // );

        if(!$(sectionRef.current).hasClass('anim-complete')){
            $(window).on('scroll', () => {
                if(isInViewport($(sectionRef.current), (0-($(window).height()/4)) )){
                    // let scroll_factor = 3;
                    // let scroll_limit = 85;
                    // $(sectionRef.current).addClass('anim-complete');
                    // let scroll_pos = $(window).scrollTop();
                    // let move_by = (scroll_pos / scroll_factor);
                    // move_by = (move_by >= scroll_limit) ? scroll_limit : move_by;
                    // TweenMax.to(bgRef.current, 0.25, {
                    //     y : 0 - move_by
                    // });

                    $(sectionRef.current).addClass('anim-complete');
                    let scroll_factor = 5;
                    let scroll_limit = 90;
                    let ref_offset = $(sectionRef.current).offset();
                    let scroll_pos = $(window).scrollTop();

                    if(ref_offset){
                        if(scroll_pos > (ref_offset.top - $(window).height()) ){
                            let move_by = ((scroll_pos - ref_offset.top) / scroll_factor);
                            move_by = (move_by >= scroll_limit) ? scroll_limit : move_by;
        
                            TweenMax.to(bgRef.current, 0.25, {
                                y : 0 - move_by
                            });
                        }
                    }
                }
            });
        }

        if(!$(wistiaRef.current).hasClass('embed-initialized') && hasWistia){
            $(wistiaRef.current).addClass('embed-initialized')
            $(wistiaRef.current).html('<script src="https://fast.wistia.com/embed/medias/'+props.wistiaId+'.jsonp" async></script><script src="https://fast.wistia.com/assets/external/E-v1.js" async></script><div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_'+props.wistiaId+' videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/'+props.wistiaId+'/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div></div></div>');
        }
    });

    let sectionContentClass = (hasWistia) ? styles.sectionContent+' '+styles.sectionContent__wistia : styles.sectionContent;

    return (
        <>
            <Helmet
                bodyAttributes={{
                    class: 'leading-normal tracking-normal home-hero-enabled'
                }}
            />
            <div className={styles.sectionLookUpWidget} style={{ backgroundColor: `${bgColor}`}} ref={sectionRef}>

                {
                    (bgImageDesktop && !hasWistia) ?
                    <div className={styles.bgImageDesktop} ref={bgRef} style={{ backgroundImage : `url("${bgImageDesktop}")`}}>
                    </div>
                    : ``
                }

                {
                    (bgImageMobile && !hasWistia) ?
                    <div className={styles.bgImageMobile} style={{ backgroundImage : `url("${bgImageMobile}")`}}>
                    </div>
                    : ``
                }
                
                <div className={styles.innerWrap}>
                    <div className={styles.bannerWrap}>
                        <div className={containerClass}>
                            <div className={styles.sectionContentWrap}>
                                <div className={sectionContentClass}>
                                    <div className={styles.sectionTexts}>
                                        <h1 ref={titleRef}>
                                            <PortableText blocks={props.heading} />
                                        </h1>
                                        <div ref={contentRef} className={styles.contentWrap}>
                                            <PortableText blocks={props.content} />
                                        </div>
                                        <div className={styles.searchBox}>
                                            <div className={styles.searchBoxHeading}>
                                                <div className={styles.headingLabel}>
                                                    <h3>{props.input_box_heading}</h3>
                                                    <h5>{props.input_box_subheading}</h5>
                                                </div>
                                                <div className={styles.headingBtn}>
                                                    {
                                                        (props.video_cta_label) ?
                                                            <a href="javascript:void(0);" className={styles.watchBtn} onClick={openVideoModal}>
                                                                <span>{props.video_cta_label}</span>
                                                            </a>
                                                        : ``
                                                    }
                                                </div>
                                            </div>
                                            <div className={styles.searchInputContainer}>
                                                <div className={styles.searchInputWrap} ref={inputWrapRef}>
                                                    <svg id="Search" xmlns="http://www.w3.org/2000/svg" width="15.413" height="16.08" viewBox="0 0 15.413 16.08" ref={searchBtn}>
                                                        <g id="Ellipse_35" data-name="Ellipse 35" fill="none" stroke="#ff7800" stroke-width="2">
                                                            <ellipse cx="6.743" cy="6.662" rx="6.743" ry="6.662" stroke="none"/>
                                                            <ellipse cx="6.743" cy="6.662" rx="5.743" ry="5.662" fill="none"/>
                                                        </g>
                                                        <line id="Line_487" data-name="Line 487" transform="translate(13.8 13.639)" fill="none" stroke="#707070" stroke-width="1"/>
                                                        <path id="Path_372" data-name="Path 372" d="M0,0,2.537,2.747" transform="translate(11.463 11.92)" fill="none" stroke="#ff7800" stroke-linecap="round" stroke-width="2"/>
                                                    </svg>
                                                    <div className={styles.clearBtn} ref={clearBtn}>&times;</div>
                                                    <Autocomplete
                                                        apiKey={googleAPIKey}
                                                        onPlaceSelected={(place) => {
                                                            console.log(place);
                                                            window.location = 'https://app.homesta.com.au/property-search?address='+encodeURIComponent(place.formatted_address);                                                        
                                                        }}
                                                        options={autoCompleteOptions}
                                                    />
                                                </div>
                                            </div>
                                            <div className={styles.boxFooter}>
                                                <h5>{props.icons_heading}</h5>
                                                <div className={styles.iconsWrapper}>
                                                    {
                                                        (icon1) ?
                                                        <a href={icon1_link} target="_blank" className={icon1_class}>
                                                            <img alt={icon1_alt} src={icon1} />
                                                        </a>
                                                        : ``
                                                    }
                                                    {
                                                        (icon2) ?
                                                        <a href={icon2_link} target="_blank" className={icon2_class}>
                                                            <img alt={icon2_alt} src={icon2} />
                                                        </a>
                                                        : ``
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    (hasWistia) ? 
                                    <div className={styles.wistiaCol}>
                                        <div className={styles.wistiaWrapper} ref={wistiaRef}>
                                        </div>
                                    </div>
                                    : ``
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <VideoModal videoSrc={videoSrc} isOpen={videoModalOpen} closeVideoModal={closeVideoModal} />
        </>
    );
}

export default LookUpWidget;
